module.exports = __webpack_public_path__ + "static/media/Civil 3D.f7b08d10.png";